import { query_service_detail_list, update_service_detail_image } from '@/api/mjstore-model';
import { TableColumn } from '@/typing';
import { SearchConfig, Record } from '@/components/page-model/typing';
import {
  slotList,
  btn_list,
  head_btn_list,
  event_obj,
} from '@/components/page-model2/mjstore/mjstore-servicedetail-config';

import { reactive } from 'vue';

import modalBox from '@/components/form-modal/modal-tools';
import { message } from 'ant-design-vue';

const None = null;
const search_config: SearchConfig = {
  settings: {},
  fields: [],
  rules: {},
  model: reactive({}),
};
const search_options = {};

const edit_model_config: SearchConfig = {
  settings: {},
  fields: [],
  rules: {},
  model: reactive({}),
};
const edit_model_config_options = {};

const update_model_config: SearchConfig = {
  settings: {},
  fields: [],
  rules: {},
  model: reactive({}),
};
const update_model_config_options = {};

const titleList = {
  title: '撤单管理',
  addModalTitle: '新建撤单',
  updateTitle: '修改撤单',
  is_create: false, // 是否有【新建】按钮
  is_update: false, // 是否有【修改】按钮
  is_remove: false, // 是否有【删除】按钮
  is_recover: false, // 是否有【恢复】按钮
};

const api_fields: Record = {};

const baseColumns: TableColumn[] = [
  {
    title: '序号',
    dataIndex: 'index',
    width: 50,
    fixed: 'left',
    slots: { customRender: 'index' },
  },
  {
    title: '耗单日期',
    width: 150,
    dataIndex: 'order_used_record__date',
    checked: true,
    slots: { customRender: 'datetime' },
  },
  {
    title: '耗单号',
    width: 170,
    dataIndex: 'order_used_record__order_code',
    checked: true,
  },
  {
    title: '项目名称',
    width: 150,
    dataIndex: 'order_used_record__project__name',
    checked: true,
  },
  {
    title: '项目次数',
    width: 80,
    dataIndex: 'order_used_record__num',
    checked: true,
  },
  {
    title: '效果图',
    width: 170,
    dataIndex: 'image_list',
    slots: { customRender: 'image_list' },
    checked: true,
  },
  {
    title: '注意事项',
    width: 120,
    dataIndex: 'note',
    checked: true,
  },

  {
    title: '服务执行门店',
    width: 120,
    dataIndex: 'order_used_record__shop__name',
    checked: true,
  },
  {
    title: '服务执行人',
    width: 100,
    dataIndex: 'order_used_record__staff__name',
    checked: true,
  },
  {
    title: '服务记录/诊断记录',
    width: 180,
    dataIndex: 'service_note',
    checked: true,
  },
  {
    title: '回访记录',
    width: 260,
    dataIndex: 'customer_feedback',
    checked: true,
  },
  {
    title: '记录执行门店',
    width: 120,
    dataIndex: 'shop__name',
    checked: true,
  },
  {
    title: '记录执行人',
    width: 120,
    dataIndex: 'staff__name',
    checked: true,
  },
  {
    title: '记录日期',
    width: 150,
    dataIndex: 'date',
    checked: true,
    slots: { customRender: 'datetime' },
  },
  {
    title: '操作',
    dataIndex: 'action',
    checked: true,
    width: 120,
    slots: { customRender: 'action' },
    fixed: 'right',
  },
];
const newSlotList: any = [];
Object.assign(newSlotList, slotList);

newSlotList.push({
  type: 'click',
  slotName: 'image_list',
  content: (record: any) => {
    if (record.before_image_json.length == 0 && record.after_image_json.length == 0) {
      return '未上传图片';
    }
    return (
      '服务前' +
      record.before_image_json.length +
      '张；' +
      '服务后' +
      record.after_image_json.length +
      '张'
    );
  },
  cb: (record: any) => {
    console.log('record', record);
    const editModal = reactive({
      visible: true,
      before_image_list: record.before_image_json,
      after_image_list: record.after_image_json,
      component: 'double-image-info-modal',
      ok: () => {},
    });
    modalBox(editModal);
  },
});

export default () => {
  return {
    searchConfig: search_config,
    searchConfigOptions: search_options,
    formModalConfig: edit_model_config,
    formModalConfigOptions: edit_model_config_options,
    updateFormModalConfig: update_model_config,
    updateFormModalConfigOptions: update_model_config_options,
    queryData: query_service_detail_list,
    addData: None,
    updateData: None,
    removeData: None,
    recoverData: None,
    baseColumns: baseColumns,
    slotList: newSlotList,
    titleList: titleList,
    api_fields: api_fields,
    btn_list: btn_list,
    head_btn_list: head_btn_list,
    event_obj: event_obj,
  };
};
